import { Fragment } from "react";
import Header from "../../components/Header";
import HowWorks from "./HowWorks";
import MainContent from "./MainContent";
import InfoSection from "./InfoSection";
import ValidateInfomation from "./ValidateInfomation";
import Testimonial from './Testimonial';
import FAQ from "./FAQ";
import './index.scss'

const Home = (props) => {
	return (
		<div className="pageWrapper">
			<Header props={props}/>
			<MainContent  props={props} />
			<HowWorks />
			<InfoSection />
			<ValidateInfomation />
			<Testimonial />
			<FAQ />
		</div>
	)
}

export default Home;